import { Component } from 'react'
import PropTypes from 'prop-types'

import Button from 'components/common/Button'
import theme from 'theme'
import TrackedExternalLink from 'components/common/TrackedExternalLink'

export default class AgreeToTerms extends Component {
  static propTypes = {
    isLoading: PropTypes.bool,
    evaluation: PropTypes.bool,
    handleEnabledChanged: PropTypes.func
  }

  render() {
    return (
      <div className="formFields">
        <label>
          <input
            data-test-evaluation-agreed
            checked={Boolean(this.props.evaluation)}
            css={{ margin: theme.space[2] }}
            type="checkbox"
            onChange={this.props.handleEnabledChanged}
          />
          I have read and agree to the {'  '}
          <span>
            <TrackedExternalLink href="https://www.gremlin.com/license">
              evaluation agreement
            </TrackedExternalLink>
          </span>
        </label>
        <Button
          data-test-agree-to-terms
          stretch
          css={{ marginTop: theme.space[3] }}
          disabled={!this.props.evaluation || this.props.isLoading}
          type="submit"
        >
          <span>Continue</span>
        </Button>
      </div>
    )
  }
}
